import React from 'react';
import { Redirect } from 'react-router-dom';

import {
  ContactLensHeaderImage,
  ContactLensHeaderTitle,
  ContactLensType,
  ContactLensSelectPowerAndBoxes,
  ContactLensDetails,
  ContactLensFAQs,
  ContactLensStoreBenefit,
  ContactLensStoreBenefitExtra,
  ContactLensButtons,
  ContactLensColours,
  ContactLensRelatedProduct,
  ContactLensRichContent,
} from './components';

import {
  HEADER_COLOUR_CONTACT_LENS_DESCRIPTION as HEADER_DESCRIPTION,
  LENS_DETAILS,
  RELATED_PRODUCTS,
} from './mockupConstants';
import './BaseContactLensPDP.scss';

const ContactLensColourPDP = props => {
  const { productData } = props;
  const baseImageUrl = 'https://static.lenskart.com/owndays/img/contact-lens-pdp';
  const isPreProd = process.env.ENVIRONMENT === 'preprod';

  if (!isPreProd) {
    return <Redirect to="/" />;
  }

  return (
    <div className="base-contact-lens-pdp">
      <div className="base-contact-lens-pdp__view-sp">
        <ContactLensHeaderImage baseImageUrl={baseImageUrl} productData={productData} />
        <ContactLensHeaderTitle baseImageUrl={baseImageUrl} data={HEADER_DESCRIPTION} />
        <ContactLensType isDailyOnly />
        <ContactLensColours baseImageUrl={baseImageUrl} />
        <ContactLensSelectPowerAndBoxes hasWithOrWithoutPower />
        <ContactLensDetails data={LENS_DETAILS} />
        <ContactLensRichContent isColourContactLens />
        <ContactLensFAQs />
        <ContactLensStoreBenefit baseImageUrl={baseImageUrl} />
        <ContactLensButtons isFixedBottom />
        <ContactLensRelatedProduct baseImageUrl={baseImageUrl} list={RELATED_PRODUCTS} />
      </div>

      <div className="base-contact-lens-pdp__view-pc">
        <div>
          <ContactLensHeaderImage baseImageUrl={baseImageUrl} productData={productData} />
          <ContactLensRichContent isColourContactLens />
          <ContactLensRelatedProduct baseImageUrl={baseImageUrl} list={RELATED_PRODUCTS} />
        </div>

        <div>
          <ContactLensHeaderTitle baseImageUrl={baseImageUrl} data={HEADER_DESCRIPTION} />
          <ContactLensType isDailyOnly />
          <ContactLensColours baseImageUrl={baseImageUrl} />
          <ContactLensSelectPowerAndBoxes hasWithOrWithoutPower />
          <ContactLensButtons />
          <ContactLensStoreBenefitExtra baseImageUrl={baseImageUrl} />
          <ContactLensDetails data={LENS_DETAILS} />
          <ContactLensFAQs />
          <ContactLensStoreBenefit baseImageUrl={baseImageUrl} />
        </div>
      </div>
    </div>
  );
};

export default ContactLensColourPDP;
